export const LATEST_VERSION = 'latest';
